<script setup lang="ts">
import SalesTrend from "@/views/playground/planner/business-management/statistics/SalesTrend.vue";
</script>

<template>
  <sales-trend></sales-trend>
</template>

<style scoped></style>
